import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import { supportContactContent } from "../../data/content";
import { handleTrackingClick } from "../../helpers/helpers";
import styles from "./complaints.module.css";
var Complaints = function() {
    var trackEvent = useAnalytics().trackEvent;
    var whatsAppHref = supportContactContent.whatsAppHref, callCta = supportContactContent.callCta, complaintsHeading1 = supportContactContent.complaintsHeading1, complaintsHeading2 = supportContactContent.complaintsHeading2, complaintsParagraphs1 = supportContactContent.complaintsParagraphs1, complaintsParagraphs2 = supportContactContent.complaintsParagraphs2, complaintsAddress = supportContactContent.complaintsAddress, complaintsEmailCta = supportContactContent.complaintsEmailCta, pressHeading = supportContactContent.pressHeading, pressBody = supportContactContent.pressBody, pressCta = supportContactContent.pressCta;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.complaints,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsx(Text, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: styles.heading,
                            children: complaintsHeading1
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cx(styles.textWrapper, styles.complaintsParagraphsWrapper),
                        children: complaintsParagraphs1 && complaintsParagraphs1.map(function(paragraph, index) {
                            return /*#__PURE__*/ _jsx("p", {
                                className: styles.paragraph,
                                children: paragraph
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsx("table", {
                        className: styles.complaintsContactTable,
                        children: /*#__PURE__*/ _jsxs("tbody", {
                            children: [
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Phone:"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "tel:".concat(callCta),
                                                "aria-label": callCta,
                                                className: styles.link,
                                                onClick: function() {
                                                    return handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints phone click",
                                                        label: callCta,
                                                        category: "phone"
                                                    });
                                                },
                                                children: callCta
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Email:"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: "mailto:".concat(complaintsEmailCta),
                                                "aria-label": complaintsEmailCta,
                                                className: styles.link,
                                                onClick: function() {
                                                    return handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints email click",
                                                        label: complaintsEmailCta,
                                                        category: "email"
                                                    });
                                                },
                                                children: complaintsEmailCta
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "Live Chat:"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx("a", {
                                                href: whatsAppHref,
                                                "aria-label": "whatsApp complaints link",
                                                className: styles.link,
                                                onClick: function() {
                                                    return handleTrackingClick(trackEvent, {
                                                        eventName: "Support - complaints whatsApp click",
                                                        label: whatsAppHref,
                                                        category: "live chat"
                                                    });
                                                },
                                                children: whatsAppHref
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "s",
                                                fontWeight: "semibold",
                                                children: "In Writing:"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "s",
                                                fontWeight: "book",
                                                className: styles.complaintsAddress,
                                                children: complaintsAddress
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsx(Text, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: styles.heading,
                            children: complaintsHeading2
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cx(styles.textWrapper, styles.complaintsParagraphsWrapper),
                        children: complaintsParagraphs2.map(function(paragraph, index) {
                            return /*#__PURE__*/ _jsx("p", {
                                className: styles.paragraph,
                                dangerouslySetInnerHTML: {
                                    __html: paragraph
                                }
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.press,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsx(Text, {
                            fontSize: "m",
                            fontWeight: "semibold",
                            className: styles.heading,
                            children: pressHeading
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsx("p", {
                            className: styles.paragraph,
                            children: pressBody
                        })
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "mailto:".concat(pressCta),
                        "aria-label": "press link",
                        className: styles.link,
                        onClick: function() {
                            return handleTrackingClick(trackEvent, {
                                eventName: "Support - complaints press click",
                                label: pressCta,
                                category: "email"
                            });
                        },
                        children: pressCta
                    })
                ]
            })
        ]
    });
};
export default Complaints;
